import { createContext, useContext } from "react";
import container from "@src/container";

const ContainerContext = createContext(container);

export function ContainerProvider({ children }) {
  return (
    <ContainerContext.Provider value={container}>
      {children}
    </ContainerContext.Provider>
  );
}

export function useContainer() {
  const context = useContext(ContainerContext);
  if (!context) {
    throw new Error("useContainer must be used within ContainerProvider");
  }
  return context;
}
